import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const ProductSection = ({ data }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} className="bg-[#0A0A0A] py-20 lg:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="text-[#C8102E] text-base md:text-lg tracking-[0.2em] font-medium uppercase mb-6">
            {data.label}
          </div>
          
          <h2
            className="text-white font-bold text-4xl md:text-5xl mb-4"
            style={{ fontFamily: "'Ubuntu', sans-serif" }}
          >
            {data.headline}
          </h2>

          <p
            className="text-[#F0EBE3] text-lg max-w-2xl mx-auto mb-16"
            style={{ fontFamily: "'Ubuntu', sans-serif" }}
          >
            {data.subtext}
          </p>
        </motion.div>

        {/* Phone Mockups */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex justify-center items-center gap-8 mb-12 flex-wrap"
        >
          {/* Left Phone */}
          <motion.div
            initial={{ opacity: 0, rotate: -5, y: 30 }}
            animate={isInView ? { opacity: 1, rotate: -3, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="w-64 h-[520px] bg-black rounded-[3rem] p-2 shadow-2xl hover:scale-105 transition-transform duration-300"
          >
            <div className="w-full h-full rounded-[2.5rem] overflow-hidden relative">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-black rounded-b-3xl z-10"></div>
              <img 
                src="https://customer-assets.emergentagent.com/job_sefer-istanbul/artifacts/t1szxoze_mockup1.png"
                alt="SEFER App - Ana Ekran"
                className="w-full h-full object-cover object-top pt-7"
              />
            </div>
          </motion.div>

          {/* Center Phone - Main */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 30 }}
            animate={isInView ? { opacity: 1, scale: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="w-72 h-[600px] bg-black rounded-[3rem] p-2 shadow-2xl hover:scale-105 transition-transform duration-300"
          >
            <div className="w-full h-full rounded-[2.5rem] overflow-hidden relative">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-36 h-7 bg-black rounded-b-3xl z-10"></div>
              <img 
                src="https://customer-assets.emergentagent.com/job_sefer-istanbul/artifacts/us0ovc7o_mockup2.png"
                alt="SEFER App - Kaseli İşler"
                className="w-full h-full object-cover object-top pt-7"
              />
            </div>
          </motion.div>

          {/* Right Phone */}
          <motion.div
            initial={{ opacity: 0, rotate: 5, y: 30 }}
            animate={isInView ? { opacity: 1, rotate: 3, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="w-64 h-[520px] bg-black rounded-[3rem] p-2 shadow-2xl hover:scale-105 transition-transform duration-300"
          >
            <div className="w-full h-full rounded-[2.5rem] overflow-hidden relative">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-black rounded-b-3xl z-10"></div>
              <img 
                src="https://customer-assets.emergentagent.com/job_sefer-istanbul/artifacts/rt3nzg0i_mockup3.png"
                alt="SEFER App - Ekspres Teslimat"
                className="w-full h-full object-cover object-top pt-7"
              />
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="text-center"
        >
          <p
            className="text-[#F0EBE3]/50 text-sm"
            style={{ fontFamily: "'Ubuntu', sans-serif" }}
          >
            {data.footer}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProductSection;
